import PropTypes from 'prop-types';
import React from 'react';
let TimedHomepageBanner = function (props) {
    const [currentDate, setCurrentDate] = React.useState(null);
    React.useEffect(() => {
        if (currentDate === null) {
            setCurrentDate(new Date());
        }
    });

    if (currentDate !== null && currentDate >= props.startDate && currentDate <= props.endDate) {
        return (
            <div className={props.name}>
                {props.children}
            </div>
        );
    } else {
        return null;
    }
};

TimedHomepageBanner.propTypes = {
    name: PropTypes.string.isRequired,
    startDate: PropTypes.instanceOf(Date).isRequired,
    endDate: PropTypes.instanceOf(Date).isRequired,
    children: PropTypes.node.isRequired,
};
TimedHomepageBanner = React.memo(TimedHomepageBanner);


const bhmStartDate = new Date('2025-02-01'); /* start date Feb 1 12:00:00AM local time*/
const bhmEndDate = new Date('2025-03-01'); /* end date March 1 12:00:00AM local time */
let BHMBanner = function () {
    return (
        <TimedHomepageBanner name={'gp-banner bhm-banner'} startDate={bhmStartDate} endDate={bhmEndDate}>
            <div className="container">
                <div className="side-container">
                    <p>Black History Month</p>

                </div>
                <div className="inside-container">

                    <img className="desktop" src="https://www.donorschoose.org/images/misc/blue-highlighter-pencil.png"
                         alt="illustration of a pencil"/>

                    <div>

                        <h3>Celebrate Black History in the Making</h3>

                        <p className="subheader">
                            Give to projects that support Black teachers and students.
                        </p>



                    </div>

                    <a href={`${baseURL}bhm25`} className="button-secondary button-overlay small">
                        View projects
                    </a>


                </div>
            </div>

        </TimedHomepageBanner>
    );
};
BHMBanner = React.memo(BHMBanner);

const whmStartDate = new Date('2024-03-01'); /* start date March 1 12:00:00AM local time */
const whmEndDate = new Date('2024-04-01'); /* end date April 1 12:00:00AM local time */
let WHMBanner = function () {
    return (
        <TimedHomepageBanner name={'gp-banner whm-banner'} startDate={whmStartDate} endDate={whmEndDate}>
            <div className="container">
                <div className="inside-container">
                    <h3>March is Women&apos;s History Month!</h3>
                    <p>
                        <a href={`${baseURL}giving/donorschoose-well/21701699/?active=true`}
                           className="button-secondary button-overlay small">
                            See some of our favorite classroom projects
                        </a>
                    </p>

                </div>
            </div>
        </TimedHomepageBanner>
    );
};
WHMBanner = React.memo(WHMBanner);


const aapiStartDate = new Date('2024-05-01'); /* start date May 1 12:00:00AM local time */
const aapiEndDate = new Date('2024-06-01'); /* end date June 1 12:00:00AM local time */
let AapiBanner = function () {
    return (
        <TimedHomepageBanner name={'gp-banner aapi-banner'} startDate={aapiStartDate} endDate={aapiEndDate}>
            <div className="container">
                <div className="inside-container">
                    <h3>
                        Celebrate Asian American & Pacific Islander Heritage Month
                    </h3>
                    <p>
                        Support these projects by AAPI teachers & teachers at schools where most of the students are AAPI.
                    </p>
                    <a href={`${baseURL}aapi24`} className="button-secondary button-overlay small" >
                        View projects
                    </a>
                </div>
            </div>
        </TimedHomepageBanner>
    );
};
AapiBanner = React.memo(AapiBanner);

const prideStartDate = new Date('2024-06-01');
const prideEndDate = new Date('2024-07-01'); /* end date July 1 12:00:00AM local time */
const juneteenthStartDate = new Date('2023-06-17');
const juneteenthEndDate = new Date('2023-06-20'); /* end date June 20 12:00:00AM local time */
let PrideJuneteenthBanner = function () {
    return (
        <div className="flex-container">
            <TimedHomepageBanner name={'gp-banner pride-banner'} startDate={prideStartDate} endDate={prideEndDate}>
                <div className="container">
                    <div className="inside-container">
                        <div>
                        <h3>Celebrate Pride Month</h3>
                        <p>
                            Give to projects that support LGBTQ students or bring representative resources into the classroom.
                        </p>
                        </div>
                        <a href={`${baseURL}pride24`} className="button-primary" >
                            View projects
                        </a>
                    </div>
                </div>
            </TimedHomepageBanner>
            <TimedHomepageBanner name={'gp-banner juneteenth-banner'} startDate={juneteenthStartDate} endDate={juneteenthEndDate}>
                <div className="container">
                    <div className="inside-container">
                        <h3>Celebrate Juneteenth with teachers and students</h3>
                        <p>
                            Join these classrooms that are lifting up Black voices.
                        </p>
                        <a href={`${baseURL}donors/search.html?keywords=Juneteenth`} className="button-secondary button-overlay small" >
                            Support a project in honor of Juneteenth
                        </a>
                    </div>
                </div>
            </TimedHomepageBanner>
        </div>
    );
};
PrideJuneteenthBanner = React.memo(PrideJuneteenthBanner);




const HLXStartDate = new Date('2024-09-15');/* start date September 15 12:00:00AM local time */
const HLXEndDate = new Date('2024-10-16'); /* end date October 16 12:00:00AM local time */
const IPDStartDate = new Date('2022-10-08');/* start date October 08 12:00:00AM local time */
const IPDEndDate = new Date('2022-10-11'); /* end date October 11 12:00:00AM local time */
let HLXIPDBanner = function () {

    return (
        <div className="flex-container">
            <TimedHomepageBanner name={'gp-banner hlx-banner'} startDate={HLXStartDate} endDate={HLXEndDate}>
                <div className="container">
                    <div className="side-container">
                        <p>Hispanic and Latinx Heritage Month</p>

                    </div>
                    <div className="inside-container">

                        <img className="desktop" src="https://www.donorschoose.org/images/misc/hlhm-pencil.png" alt="illustration of a pencil" />

                        <div>

                            <h3>Celebrate Hispanic and Latinx Heritage Month!</h3>

                            <p className="subheader">Give to projects that support Hispanic Latinx teachers or students.</p>

                            <img className="mobile" src="https://www.donorschoose.org/images/misc/hlhm-pencil.png"
                                 alt="illustration of a pencil"/>

                        </div>

                        <a href={`${baseURL}hlhm25`} className="button-secondary button-overlay small" >
                            View projects
                        </a>



                    </div>
                </div>

            </TimedHomepageBanner>

            <TimedHomepageBanner name={'gp-banner ipd-banner'} startDate={IPDStartDate} endDate={IPDEndDate}>
                <div className="container">
                    <div className="inside-container">
                        <h3>Celebrate Indigenous Peoples' Day &mdash; October 10</h3>

                        <div>
                            <p>See how teachers are lifting up Indigenous voices and history in their classrooms.</p>

                            <a href={`https://www.donorschoose.org/blog/indigenous-peoples-day/`} className="button-secondary button-overlay small" >
                                Read more
                            </a>
                        </div>

                    </div>
                </div>
            </TimedHomepageBanner>
        </div>
    );


};
HLXIPDBanner = React.memo(HLXIPDBanner);


const DisasterReliefStartDate = new Date('2022-10-01');/* start date November 1 12:00:00AM local time */
const DisasterReliefBEndDate = new Date('2022-10-09'); /* end date December 1 12:00:00AM local time */
let DisasterReliefBanner = function () {
    return (
        <TimedHomepageBanner name={'gp-banner disasterrelief-banner'} startDate={DisasterReliefStartDate} endDate={DisasterReliefBEndDate}>
            <div className="container">
                <div className="badge"> Disaster Relief</div>
                <div className="inside-container">


                    <h3>Help teachers and students recovering from Hurricane Ian.</h3>
                    <a href={baseURL + 'hurricane-ian'} className="button-secondary button-overlay small" >
                        Give now
                    </a>

                </div>
            </div>

        </TimedHomepageBanner>
    );


};
DisasterReliefBanner = React.memo(DisasterReliefBanner);


const NAHMStartDate = new Date('2024-11-01');/* start date November 1 12:00:00AM local time */
const NAHMEndDate = new Date('2024-12-01'); /* end date December 1 12:00:00AM local time */
let NAHMBanner = function () {
    return (
        <TimedHomepageBanner name={'gp-banner nahm-banner'} startDate={NAHMStartDate} endDate={NAHMEndDate}>

            <div className="container">
                <div className="side-container">
                    <p>Native&nbsp;American <span className="mobile"></span>Heritage Month</p>

                </div>
                <div className="inside-container">

                    <img className="desktop" src="https://www.donorschoose.org/images/misc/hlhm-pencil.png" alt="illustration of a pencil" />

                    <div>

                        <h3>Celebrate Native American Heritage&nbsp;Month</h3>

                        <p className="subheader">Give to projects that support Native American teachers or&nbsp;students</p>

                    </div>

                    <a href={`${baseURL}nahm25`} className="button-secondary button-overlay small" >
                        View projects
                    </a>



                </div>
            </div>
        </TimedHomepageBanner>
    );


};
NAHMBanner = React.memo(NAHMBanner);


const EFSMatchStartDate = new Date('2022-09-20');/* start date November 1 12:00:00AM local time */
const EFSMatchEndDate = new Date('2022-09-21'); /* end date December 1 12:00:00AM local time */
let EFSFlashMatchBanner = function () {
    return (
        <TimedHomepageBanner name={'gp-banner EFSMatch-banner'} startDate={EFSMatchStartDate} endDate={EFSMatchEndDate}>
            <div className="container">
                <div className="inside-container">

                    <p><strong>Matched Donations:</strong> Today only, all donations to projects from Equity Focus Schools are doubled!</p>
                    <p><a href={baseURL + 'donors/search.html' + '?' + 'equityFocus=true'} role='link'>Support a classroom now</a></p>

                </div>
            </div>

        </TimedHomepageBanner>
    );


};
EFSFlashMatchBanner = React.memo(EFSFlashMatchBanner);



export let CalendarBannerSection = function() {
    return (
        <div className="calendar-banners">
            <BHMBanner />
            <WHMBanner />
            <AapiBanner />
            <PrideJuneteenthBanner />
            <DisasterReliefBanner />
            <NAHMBanner/>
            <EFSFlashMatchBanner/>
            <HLXIPDBanner/>
        </div>
    );
};
CalendarBannerSection = React.memo(CalendarBannerSection);

